import environment from "../environment";
import { GET, GETWithParams, POST } from "./http.service";

const _endpoint = environment.LESSON_ENDPOINT;
const _token = environment.TOKEN_KEY;

export const getLessonVideo = async (slug) => {
  const response = await GET(
    `${_endpoint}/${slug}`,
    localStorage.getItem(_token)
  );
  return response;
};

export const getRecordedLiveLessonVideo = async (slug) => {
  const response = await GET(
    `CourseSession/${slug}/details`,
    localStorage.getItem(_token)
  );
  return response;
};

export const getRecordedLiveLessonVideoForMobile = async (slug, token) => {
  const response = await GET(`CourseSession/${slug}/details`, token);
  return response;
};

export const getLessonData = async (slug) => {
  const response = await GET(
    `CourseRecordedSession/${slug}`,
    localStorage.getItem(_token)
  );
  return response;
};

export const getAllComments = async (slug) => {
  const response = await GETWithParams(
    `SessionComment`,
    { sessionId: slug },
    localStorage.getItem(_token)
  );
  return response;
};

export const AddComment = async (bodyRequest) => {
  const response = await POST(
    `SessionComment`,
    bodyRequest,
    localStorage.getItem(_token)
  );
  return response;
};
